export default __webpack_public_path__ + "static/media/Wristwraps of Concealing Shadows.d3488d01.jpg";